var PrivacyPolicyView = Backbone.Epoxy.View.extend({
  /**
   * Name of the template file to use to render (search path is /assets/templates/app)
   * Directory separators are replaced with periods.
   */
  template: 'privacyPolicy',

  /**
   * The `bindings` attribute should be set to `'data-bind'` if you will use data binding.
   *
   * This tells Epoxy to look for binding declarations in the data-bind attributes in the HTML markup.
   */
  bindings: 'data-bind',

  /**
   * Backbone events.  Hash of 'dom-event-name css-selector' : '{functionName}'
   */
  events: {
  },

  bindingSources: {
  },

  /**
   * Called when this object is instantiated.
   */
  initialize: function() {
    this.model = new Backbone.Model();

    var self = this;
    $(window).resize(function() {
      self.fixContentHeight();
    })

  },

  fixContentHeight: function () {
    var topBarHeight = $('.top-bar').height();
    var height = $(window).height() - topBarHeight;

    $('#clientProfile').css('height', height);
  },

  /**
   * Called before this view is displayed to the user.
   * Clean up defaults and reset page status, etc.
   * Returns a boolean to signify whether the rendering should continue.
   */
  beforeRender: function() {
    return true;
  },

  /**
   * Called after this view is displayed.
   * Set focus, do after-render animations, etc.
   */
  afterRender: function() {
    //You must keep this line if you want to use data binding, otherwise remove it
    this.applyBindings();

    this.fixContentHeight();

    bookedby.app.finishLoading();
  },

  /**
   * Called before your view is removed from the DOM.
   *
   * If you attach custom events or initialize UI components in afterRender(), you should remove those events or destory those components here.
   */
  cleanup: function() {
    //You must keep this line if you want to use data binding, otherwise remove it
    this.removeBindings();
  },

  /**
   * Called on navigation.
   *
   * * newData is an object parsed from the URL query parameters
   * * path is set to the name of the page/route
   */
  setData: function() {
  }

});

/**
 * Export this view as a class.
 */
module.exports = PrivacyPolicyView;